import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

interface IEventMarketsSettingsContext {
  ungroup: boolean;
  setUngroup: (value: boolean) => void;
}

const EventMarketsSettingsContext =
  createContext<IEventMarketsSettingsContext | null>(null);

interface IEventMarketsSettingsProviderProps {
  children: ReactNode;
}

export const EventMarketsSettingsProvider = ({
  children,
}: IEventMarketsSettingsProviderProps) => {
  const [ungroup, setUngroup] = useState(false);

  const value = useMemo(
    () => ({
      ungroup,
      setUngroup,
    }),
    [ungroup]
  );

  return (
    <EventMarketsSettingsContext.Provider value={value}>
      {children}
    </EventMarketsSettingsContext.Provider>
  );
};

export const useEventMarketsSettings = (): IEventMarketsSettingsContext => {
  const context = useContext(EventMarketsSettingsContext);

  if (!context) {
    throw new Error(
      "useEventMarketsSettings must be used within EventMarketsSettingsProvider"
    );
  }

  return context;
};
